import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { ventas } from '../data/ventas';
const ESPERA_INICIAL = 6000;
const VISIBLE = 5500;
const PAUSA = 9000;
export function VentasFlotantes() {
  const [indice, setIndice] = useState(0);
  const [visible, setVisible] = useState(false);
  const [cerrado, setCerrado] = useState(false);
  const primera = useRef(true);
  useEffect(() => {
    if (cerrado) return;
    if (visible) {
      const ocultar = window.setTimeout(() => setVisible(false), VISIBLE);
      return () => window.clearTimeout(ocultar);
    }
    const espera = primera.current ? ESPERA_INICIAL : PAUSA;
    const siguiente = window.setTimeout(() => {
      if (primera.current) {
        primera.current = false;
      } else {
        setIndice(actual => (actual + 1) % ventas.length);
      }
      setVisible(true);
    }, espera);
    return () => window.clearTimeout(siguiente);
  }, [visible, cerrado]);
  if (cerrado) return null;
  const venta = ventas[indice];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6" aria-live="polite" data-id="element-275" data-mp="2mqdxes4bwds3">
      <AnimatePresence data-id="element-276" data-mp="30rgm7cmpk26p">
        {visible && <motion.div key={venta.nombre} initial={{
        opacity: 0,
        y: 16,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[320px] max-w-full items-center gap-3 rounded-2xl border border-edge bg-surface p-3 shadow-soft" data-id="element-277" data-mp="2vr2c7p1jqi61">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-soft text-xs font-bold text-brand-700" data-id="element-278" data-mp="3ehtszbnv5aug">
              {venta.iniciales}
            </span>

            <div className="min-w-0 flex-1" data-id="element-279" data-mp="3ogre04m2ym8p">
              <p className="truncate text-sm font-semibold text-ink" data-id="element-280" data-mp="3vio98z7xdep7">
                {venta.nombre} compró el MegaPack
              </p>
              <p className="mt-0.5 flex items-center gap-1.5 truncate text-xs text-muted" data-id="element-281" data-mp="4deq9ricm0p3">
                <CheckIcon className="h-3 w-3 shrink-0 text-verde-500" aria-hidden="true" data-id="element-282" data-mp="9b6fuevitaq4" />
                {venta.ciudad} · {venta.hace}
              </p>
            </div>

            <button type="button" onClick={() => setCerrado(true)} className="shrink-0 rounded-full p-1.5 text-muted transition-colors duration-150 ease-out hover:bg-soft hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600" aria-label="Cerrar notificaciones de compras" data-id="element-283" data-mp="j19jd909q72p">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-284" data-mp="2ttu8xdbtxhad" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}